import { render, staticRenderFns } from "./GONoGoDialog.vue?vue&type=template&id=178fa89a"
import script from "./GONoGoDialog.vue?vue&type=script&lang=js"
export * from "./GONoGoDialog.vue?vue&type=script&lang=js"
import style0 from "./GONoGoDialog.vue?vue&type=style&index=0&id=178fa89a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports